import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../client';
import type {
  LogWorkoutRequestDto,
  UpdateWorkoutRequestDto,
  WorkoutEntryDto,
} from '../types';

export function useRecentWorkouts(days = 90) {
  return useQuery({
    queryKey: ['workout', 'recent', days],
    queryFn: ({ signal }) =>
      api.get<WorkoutEntryDto[]>(`/api/workout/recent?days=${days}`, { signal }),
  });
}

export function useLogWorkout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: LogWorkoutRequestDto) => api.post<WorkoutEntryDto>('/api/workout', body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workout'] });
      void qc.invalidateQueries({ queryKey: ['today'] });
    },
  });
}

export function useUpdateWorkout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: UpdateWorkoutRequestDto }) =>
      api.put<WorkoutEntryDto>(`/api/workout/${encodeURIComponent(id)}`, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workout'] });
      void qc.invalidateQueries({ queryKey: ['today'] });
    },
  });
}

export function useDeleteWorkout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete<void>(`/api/workout/${encodeURIComponent(id)}`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workout'] });
      void qc.invalidateQueries({ queryKey: ['today'] });
    },
  });
}

export function useRestoreWorkout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.post<void>(`/api/workout/${encodeURIComponent(id)}/restore`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workout'] });
      void qc.invalidateQueries({ queryKey: ['today'] });
    },
  });
}
